import React, { useState } from "react";
import { auth, db } from "../firebaseConfig";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { toast } from "react-toastify";
import "../styles/PaySubscription.css";
import { getDoc } from "firebase/firestore";

const tierPrices = {
  basic: 7500,
  standard: 12000,
  premium: 18000,
};

const getDiscount = (months) => {
  if (months >= 10) return 0.15;
  if (months >= 6) return 0.10;
  if (months >= 3) return 0.05;
  return 0;
};

const PaySubscription = () => {
  const [tier, setTier] = useState("basic");
  const [months, setMonths] = useState(1);
  const [processing, setProcessing] = useState(false);

  const pricePerMonth = tierPrices[tier];
  const discountRate = getDiscount(months);
  const total = Math.floor(pricePerMonth * months * (1 - discountRate));

  const handlePayment = () => {
    const user = auth.currentUser;
    if (!user) {
      alert("You must be logged in");
      return;
    }

    setProcessing(true);
    console.log("PaySubscription.js - Initiating Paystack payment...");
    console.log("PaySubscription.js - Total amount (NGN):", total);
    const amountInKobo = total * 100;
    console.log("PaySubscription.js - Amount in kobo:", amountInKobo);
    console.log("PaySubscription.js - User email:", user.email);

    // Check if PaystackPop is available
    if (!window.PaystackPop) {
      console.error("PaySubscription.js - PaystackPop is not defined. Ensure Paystack script is loaded.");
      toast.error("Payment failed: Paystack script not loaded.");
      setProcessing(false);
      return;
    }

    try {
      const handler = window.PaystackPop.setup({
        key: "pk_live_c67f0b0ff55d9a1114be70ded141f1b3525685ce", // Replace with your Paystack Test Public Key
        email: user.email,
        amount: amountInKobo,
        currency: "NGN",
        metadata: {
          user_id: user.uid,
          tier: tier,
          months: months,
          payment_type: "renewal",
        },
        callback: function (response) {
  const processPayment = async () => {
    console.log("PaySubscription.js - Paystack callback triggered:", response);
    toast.success("Payment successful! Reference: " + response.reference);

    try {
      const now = new Date();
      const userRef = doc(db, "users", auth.currentUser.uid);
      const userSnap = await getDoc(userRef);

      let newEndDate = new Date();
      if (userSnap.exists()) {
        const data = userSnap.data();
        const currentEnd = data.subscriptionEnd ? new Date(data.subscriptionEnd) : now;

        // If subscription is still active, extend from its end date
        if (currentEnd > now) {
          newEndDate = new Date(currentEnd);
        }

        newEndDate.setMonth(newEndDate.getMonth() + months);
      } else {
        newEndDate.setMonth(now.getMonth() + months);
      }

      await updateDoc(userRef, {
        tier,
        subscriptionEnd: newEndDate.toISOString(),
        billingHistory: arrayUnion({
          date: now.toISOString(),
          amount: total,
          months,
          tier,
          reference: response.reference,
          discount: discountRate,
          status: "success",
        }),
      });

      toast.success("Subscription updated successfully!");
    } catch (err) {
      console.error("Firestore update error:", err);
      toast.error("Failed to update subscription. Contact support.");
    }

    setProcessing(false);
  };

  processPayment(); // Call the inner async function
},
        onClose: function () {
          console.log("PaySubscription.js - Paystack payment window closed");
          toast.info("Payment window closed.");
          setProcessing(false);
        },
      });

      console.log("PaySubscription.js - Opening Paystack iframe...");
      handler.openIframe();
    } catch (error) {
      console.error("PaySubscription.js - Error initiating Paystack payment:", error);
      toast.error("Payment failed: " + error.message);
      setProcessing(false);
    }
  };

  return (
    <div className="subscription-container">
      <h2>💳 Subscribe / Renew</h2>

      <label>Choose Plan:</label>
      <select value={tier} onChange={(e) => setTier(e.target.value)}>
        <option value="basic">Basic – ₦7,500/mo</option>
        <option value="standard">Standard – ₦12,000/mo</option>
        <option value="premium">Premium – ₦18,000/mo</option>
      </select>

      <label>Duration (months):</label>
      <input
        type="number"
        min={1}
        max={12}
        value={months}
        onChange={(e) => setMonths(Number(e.target.value))}
      />

      <p>
        📉 Discount: <strong>{discountRate * 100}%</strong>
      </p>
      <p>
        💰 Total: <strong>₦{total.toLocaleString()}</strong>
      </p>

      <button onClick={handlePayment} disabled={processing}>
        {processing ? "Processing..." : "Pay with Paystack"}
      </button>
    </div>
  );
};

export default PaySubscription;